import React from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import useEmotionStyles from '../../hooks/useEmotionStyles';
var styles = function () {
    var _a, _b, _c;
    return ({
        root: (_a = {},
            _a['&.MuiAlert-standardSuccess'] = (_b = {
                    borderLeft: '6px solid #4caf50',
                    background: '#edfaeb',
                    color: '#1e4620'
                },
                _b['& .MuiAlert-icon'] = {
                    color: '#4caf50',
                },
                _b),
            _a['&.MuiAlert-standardWarning'] = (_c = {
                    borderLeft: '6px solid #ff9800',
                    background: '#fff4e5',
                    color: '#663c00'
                },
                _c['& .MuiAlert-icon'] = {
                    color: '#ff9800',
                },
                _c),
            _a),
        text: {
            color: 'inherit',
        },
    });
};
var AlertBox = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'success' : _b, title = _a.title, content = _a.content, icon = _a.icon;
    var cs = useEmotionStyles(styles);
    return (React.createElement(Alert, { severity: type, className: cs.root, icon: icon },
        !!title && React.createElement(AlertTitle, { className: cs.text }, title),
        content));
};
export default AlertBox;
